import { Component, SimpleChanges, Input } from '@angular/core';
import { eGENA_Checkliste } from '../../../visionet/Checkliste';
import { NavController } from 'ionic-angular';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';
import { SearchPhoneSelectListPage } from '../../../pages/search/Phone/SearchPhoneSelectListPage';


@Component({
	selector: 'Koerpernavigator',
	templateUrl: 'Koerpernavigator.html'
})

export class KoerpernavigatorComponent {

	@Input()
	bodynavIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	@Input()
	curSearchResultChecklists: eGENA_Checkliste[]
	@Input()
	ausgewaehlterPatiententyp: string;
	@Input()
	activeSearch: string = ''



	constructor(public globals: GlobalsSingleton, public navCtrl: NavController) {
	}




	/**	=== Visionet(sl) ==========
	 *
	 *	Lade die Trefferliste für einen ausgewähltes Organsystem
	 */
	ladeTrefferFuerOrgansystem_Suche(bodypart : string) : void {
		if (!this.isTablettOrPc()) {
			this.globals.setCurSearchResultChecklists(this.bodynavIndex[bodypart]);
			this.navCtrl.push(SearchPhoneSelectListPage, {
				activeSearch: "bodynav",
				ausgewaehlterPatiententyp: 	this.ausgewaehlterPatiententyp
				},
				{
					animate : true,
					animation: "ios-transition"
				}
			);
		}
		else {
			this.curSearchResultChecklists = this.bodynavIndex[bodypart];
		}
	}


	isTablettOrPc() : boolean {
		return !this.globals.isPhone();
	}


}



// WEBPACK FOOTER //
// ./src/components/Suche/Koerpernavigator/Koerpernavigator.ts